(function () {
  'use strict';

  function initBar(sectionId) {
    var bar = document.getElementById('sticky-atc-bar--' + sectionId);
    if (!bar) return;

    var priceEl = document.getElementById('sticky-atc-price--' + sectionId);
    var btn = bar.querySelector('[data-sticky-atc-btn]');
    if (!btn) return;

    var productSection = document.querySelector('[data-section-id="' + sectionId + '"]');
    if (!productSection) return;

    var mainAtcBtn = productSection.querySelector('.js-product-add');
    if (!mainAtcBtn) return;

    // Show bar when main ATC button scrolls out of view, hide when it re-enters
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.classList.remove('is-visible');
            bar.setAttribute('aria-hidden', 'true');
          } else {
            bar.classList.add('is-visible');
            bar.setAttribute('aria-hidden', 'false');
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(mainAtcBtn);

    // Keep the sticky bar's price in sync if the customer changes variant
    var variantSelector = document.getElementById('variant-selectors-' + sectionId);
    if (variantSelector) {
      variantSelector.addEventListener('on:variant:change', function (e) {
        if (!e.detail || !e.detail.variant) return;
        if (priceEl) {
          var pagePriceEl = document.getElementById('price-' + sectionId);
          if (pagePriceEl) {
            var moneyEl = pagePriceEl.querySelector('.price__number .money');
            if (moneyEl) priceEl.textContent = moneyEl.textContent.trim();
          }
        }
      });
    }

    btn.addEventListener('click', function () {
      btn.disabled = true;
      var labelEl = btn.querySelector('.sticky-atc-bar__btn-label');
      var addedEl = btn.querySelector('.sticky-atc-bar__btn-added');

      // Trigger the theme's own real Add to Cart button instead of running
      // a separate request. This guarantees the cart count and slide-out
      // drawer update correctly, exactly like the normal button does.
      mainAtcBtn.click();

      // Show confirmation on the sticky bar itself
      btn.classList.add('is-added');
      if (labelEl) labelEl.style.display = 'none';
      if (addedEl) addedEl.style.display = 'inline';

      setTimeout(function () {
        btn.classList.remove('is-added');
        if (labelEl) labelEl.style.display = '';
        if (addedEl) addedEl.style.display = '';
        btn.disabled = false;
      }, 2500);
    });
  }

  function init() {
    document.querySelectorAll('.sticky-atc-bar').forEach(function (el) {
      var sectionId = el.dataset.sectionId;
      if (sectionId) initBar(sectionId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();